import React from 'react';
import clsx from 'clsx';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) {
  const base = 'px-6 py-2.5 rounded-lg font-medium transition-all duration-300 inline-flex items-center justify-center text-center focus:outline-none focus:ring-2 focus:ring-[#A45DE8]/50';
  const variants = {
    primary: 'bg-gradient-to-r from-[#A45DE8] to-[#6A3683] text-white rounded-lg shadow-[0_0_15px_rgba(164,93,232,0.5)] hover:shadow-[0_0_20px_rgba(164,93,232,0.7)]',
    secondary: 'border border-[#6A3683] text-[#FBFBFE] hover:border-[#A45DE8] hover:bg-[#6A3683]/20 rounded-lg',
    outline: 'border border-[#A45DE8] text-[#A45DE8] bg-transparent hover:bg-[#A45DE8]/10 rounded-lg',
    ghost: 'bg-transparent text-[#FBFBFE] hover:bg-[#A45DE8]/10 rounded-lg',
  };
  const sizes = {
    md: '',
    sm: 'px-4 py-2 text-sm',
    lg: 'px-8 py-3 text-lg',
  };

  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className, disabled && 'opacity-60 cursor-not-allowed')}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="mr-2 animate-spin">🔮</span>}
      {children}
    </button>
  );
} 